module.exports = __webpack_public_path__ + "img/drawer-close-img.4748cd35.svg";